// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from "react";
import ReactDOM from 'react-dom';
import clsx from 'clsx';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Button } from "../Button";
import { TextLink } from "../TextLink/TextLink";
import { Status } from "../Status/Status";
import { Chip } from "../Chip/Chip";
export var Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'right' : _ref$position,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    actionProps = _ref.actionProps,
    actionType = _ref.actionType,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$triggerClassname = _ref.triggerClassname,
    triggerClassname = _ref$triggerClassname === void 0 ? '' : _ref$triggerClassname,
    _ref$tooltipClassname = _ref.tooltipClassname,
    tooltipClassname = _ref$tooltipClassname === void 0 ? '' : _ref$tooltipClassname,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var hideTimeoutRef = useRef(null);
  var triggerRef = useRef(null);
  var tooltipRef = useRef(null);
  var _useState3 = useState({
      top: 0,
      left: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    coords = _useState4[0],
    setCoords = _useState4[1];
  var updateTooltipPosition = function updateTooltipPosition() {
    if (!tooltipRef.current || !triggerRef.current) return;
    var tooltipRect = tooltipRef.current.getBoundingClientRect();
    var triggerRect = triggerRef.current.getBoundingClientRect();
    var top = 0;
    var left = 0;
    switch (position) {
      case 'top':
        top = triggerRect.top - tooltipRect.height - 8;
        left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2;
        break;
      case 'bottom':
        top = triggerRect.bottom + 8;
        left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2;
        break;
      case 'left':
        top = triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2;
        left = triggerRect.left - tooltipRect.width - 8;
        break;
      case 'right':
        top = triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2;
        left = triggerRect.right + 8;
        break;
    }
    setCoords({
      top: top,
      left: left
    });
  };
  useLayoutEffect(function () {
    if (visible) {
      updateTooltipPosition();
    }
  }, [visible, position]);
  var handleShow = function handleShow() {
    if (disabled || !content) return;
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
    }
    setVisible(true);
  };
  var handleHide = function handleHide() {
    hideTimeoutRef.current = setTimeout(function () {
      setVisible(false);
    }, 150); // Delay before hiding so that user can still interact with the tooltip
  };
  var handleClick = function handleClick() {
    if (disabled || !content) return;
    setVisible(true);
  };
  var tooltipClickEvents = {
    onClick: handleClick
  };
  var tooltipHoverEvents = {
    onPointerEnter: handleShow,
    onPointerLeave: handleHide
  };
  var triggerEvents = trigger === 'hover' ? tooltipHoverEvents : tooltipClickEvents;
  var renderAction = function renderAction() {
    if (!actionType || !actionProps) return null;
    switch (actionType) {
      case 'link':
        return /*#__PURE__*/React.createElement(TextLink, actionProps);
      case 'button':
        return /*#__PURE__*/React.createElement(Button, actionProps);
      case 'status':
        return /*#__PURE__*/React.createElement(Status, actionProps);
      case 'chip':
        return /*#__PURE__*/React.createElement(Chip, actionProps);
      default:
        return null;
    }
  };

  // Close tooltip on outside click
  useEffect(function () {
    if (trigger !== 'click' || !visible) return;
    var handleOutsideClick = function handleOutsideClick(e) {
      var _triggerRef$current$c, _triggerRef$current, _tooltipRef$current;
      var target = e.target;
      if ((_triggerRef$current$c = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.contains(target)) !== null && _triggerRef$current$c !== void 0 ? _triggerRef$current$c : (_tooltipRef$current = tooltipRef.current) === null || _tooltipRef$current === void 0 ? void 0 : _tooltipRef$current.contains(target)) {
        return;
      }
      setVisible(false);
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return function () {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [trigger, visible]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    ref: triggerRef,
    className: clsx('cop-cursor-pointer', triggerClassname)
  }, triggerEvents), children), visible && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", _extends({
    ref: tooltipRef,
    style: {
      top: coords.top,
      left: coords.left
    },
    className: clsx('cop-z-1500 cop-fixed cop-flex cop-items-center cop-gap-2 cop-rounded cop-border cop-border-solid cop-border-input-gray cop-bg-white cop-px-3 cop-py-1 cop-shadow-lg cop-transition-opacity cop-duration-200', tooltipClassname)
  }, trigger === 'hover' ? tooltipHoverEvents : {}), /*#__PURE__*/React.createElement("div", null, content), renderAction()), document.body));
};
